<template>
  <b-modal
    class="mc-modal"
    id="mc-modal-delete-bulk"
    ref="mc-modal-delete"
    :title="$t('global.action.delete')"
    size="md"
    centered
    scrollable
  >
    <div class="card-body p-2">
      <p>
        {{ $t('global.confirmDelete1') }} <strong>{{ selectedDataLength }}</strong>
        {{ $t('global.confirmDelete2') }}
      </p>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex">
        <McButton
          variant="secondary"
          :text="$t('global.action.cancel')"
          class="me-2"
          @click="cancel()"
        />
        <McButton variant="primary" :text="$t('global.action.delete')" @click="handleDelete" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import { BULK_DELETE_SERVICE_SCHEDULES } from '@/services/api/maintenance/serviceSchedules'

export default {
  components: {
    McButton,
  },

  props: {
    selectedDataLength: {},
    selectedIds: {},
    selectedItems: {},
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    hasMO() {
      return this.hasAccess([
        'service_order:read',
        'service_order:update',
        'service_order:create',
        'service_order:delete',
      ])
    },
  },

  methods: {
    async handleDelete() {
      const serviceSchedules = this.selectedItems.map((item) => {
        return {
          serviceId: item.serviceId,
          type: item.type,
          vehicleId: item.vehicleId,
        }
      })

      await this.$apollo
        .mutate({
          mutation: BULK_DELETE_SERVICE_SCHEDULES,
          variables: {
            input: {
              inputs: serviceSchedules,
            },
          },
        })
        .then((res) => {
          if (res.data.deleteServiceSchedules.isSuccessful)
            this.$mcToast.success(this.$t('global.alert.text.delete'))
          else if (res.data.deleteServiceSchedules.errorCode === 'E-SS1-D2/5')
            this.$mcToast.error(this.$t('maintenance.alert.deleteInProgress'))
          else if (res.data.deleteServiceSchedules.errorCode === 'E-SS1-D2/3')
            this.$mcToast.error(this.$t('maintenance.alert.deleteUnabled'))
          else if (res.data.deleteServiceSchedules.errorCode === 'E-SS1-D2/4')
            this.$mcToast.error(this.$t('maintenance.alert.failedDeleteMO'))
          else this.$mcToast.error(this.$t('global.alert.text.failedDelete'))
        })

      this.$bvModal.hide('mc-modal-delete-bulk')
      this.$emit('refreshPage')
    },
  },
}
</script>
